import { createContext, useEffect, useReducer, useState } from 'react';
import Fetch from '../../../functions/Fetch';
import { useSelector } from 'react-redux';
import config from '../../../../../../config/config';
import Toast from '../../../Util/Toast/Toast';
import { getSelectedYearMonthsByYear } from '../../../Dashboards/Common/Util/getMonthsByYear';

export const ChartsDataContext = createContext();

const reducer = (state, action) => {
    switch (action.type) {
        case 'FETCH_INIT':
            return {
                ...state,
                isLoading: true,
                isError: false
            };
        case 'FETCH_SUCCESS':
            return {
                ...state,
                isLoading: false,
                isError: false,
                data: action.payload
            };
        case 'FETCH_FAILURE':
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 'SET_FILTERS':
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...action.payload
                }
            };
        default:
            return state;
    }
};

const initialState = {
    data: {
        indicators: [
            {
                debit_value: 0,
                credit_value: 0
            }
        ],
        selectedYear: []
    },
    isLoading: false,
    isError: false,
    filters: {
        year: new Date().getFullYear(),
        pdc_bank_account_id: '',
        month: ''
    }
};

const ChartsDataProvider = ({ children }) => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });

    const [state, dispatch] = useReducer(reducer, initialState);
    const [months, setMonths] = useState([]);

    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const subtitles = ['Débitos', 'Créditos'];

    const fetchChartData = async () => {
        dispatch({ type: 'FETCH_INIT' });

        setMonths(getSelectedYearMonthsByYear(state.filters.year));

        try {
            const response = await Fetch.post(
                config.endpoints.backend + 'portal/getbankingresume',
                {
                    filter: {
                        ...state.filters,
                        friendly_url
                    }
                }
            );

            if (!response) {
                throw new Error('Erro ao buscar dados do gráfico');
            }

            dispatch({ type: 'FETCH_SUCCESS', payload: response });
        } catch (error) {
            dispatch({ type: 'FETCH_FAILURE' });

            Toast.error('Erro ao buscar dados do gráfico');
        }
    };

    const handleChangeFilter = (filter) => {
        dispatch({ type: 'SET_FILTERS', payload: filter });
    };

    useEffect(() => {
        fetchChartData();
    }, []);

    const colors = ['#E74C3C', '#3498DB'];

    return (
        <ChartsDataContext.Provider
            value={{
                subtitles,
                colors,
                state,
                fetchChartData,
                handleChangeFilter,
                months
            }}
        >
            {children}
        </ChartsDataContext.Provider>
    );
};

export default ChartsDataProvider;
